'use client'

import { OPEN_TELEMETRY_BADGE_TEST_IDS } from '@modules/gateways/gateways-test-ids.const'

import { OpenTelemetryIcon } from '../icons/open-telemetry'

import styles from './OpenTelemetryBadge.module.scss'

type OpenTelemetryBadgeProps = {
  className?: string
  connected?: boolean
}

export function OpenTelemetryBadge({ className, connected = false }: OpenTelemetryBadgeProps) {
  if (!connected) {
    return null
  }

  const rootClass = [styles.badge, className].filter(Boolean).join(' ')

  return (
    <span
      className={rootClass}
      data-testid={OPEN_TELEMETRY_BADGE_TEST_IDS.root}
      aria-label="OpenTelemetry connected"
      title="OpenTelemetry connected"
    >
      <OpenTelemetryIcon size={16} active className={styles.icon} />
    </span>
  )
}
